import { render, staticRenderFns } from "./OogLashingPop.vue?vue&type=template&id=3c019d02"
import script from "./OogLashingPop.vue?vue&type=script&lang=js"
export * from "./OogLashingPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c019d02')) {
      api.createRecord('3c019d02', component.options)
    } else {
      api.reload('3c019d02', component.options)
    }
    module.hot.accept("./OogLashingPop.vue?vue&type=template&id=3c019d02", function () {
      api.rerender('3c019d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/OogLashingPop.vue"
export default component.exports